import {connect} from 'react-redux';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import InfoList from "../../shared/infolist";
import {Button} from "antd";
import {withRouter} from 'react-router-dom';
import * as APP_CONFIG from "../../../constants/config";
const {benchmarkApi} = APP_CONFIG;

class LoggerList extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired,
        locationId: PropTypes.number,
        showTitle: PropTypes.bool
    };

    static defaultProps = {
        showTitle: true,
        locationId: 0
    };

    loadPage = (id) => {
        console.log("load logger", id)
        this.props.history.push(`/loggers/${id}`)
    }

    render() {
        return (
            <Fragment>
                {
                    this.props.showTitle ?
                        <h1>Loggers</h1> : ''
                }
                <InfoList dataSourceFunc={async () => {
                    const request = await fetch(`${benchmarkApi}loggers`);
                    const data = await request.json();
                    if(this.props.locationId > 0)
                        return data.filter((row) => row.location_id === this.props.locationId);
                    return data;
                }} columns={[
                    {
                        title: '#',
                        dataIndex: 'id',
                    }, {
                        title: 'Locatie',
                        dataIndex: 'name',
                        render: (text, row, index) => <Fragment>[{row.location_id}] {row.name}</Fragment>,
                    }, {
                        title: 'Laatste update',
                        dataIndex: 'last_update',
                        render: (text, row, index) => new Date(text).toLocaleString()
                    }, {
                        title: 'Acties',
                        dataIndex: 'x',
                        render: (text, row, index) => <Button onClick={() => this.loadPage(row.id)}>Bekijken</Button>,
                    }
                ]} rowKey="id" />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {return {}}

export default connect(mapStateToProps)(withRouter(LoggerList));



// WEBPACK FOOTER //
// ./src/components/baseinfo/loggers/list.js